import {useCookieValue} from '@react-hookz/web/esm/useCookieValue';
import {Popover, Transition} from '@headlessui/react';
import classNames from 'classnames';
import Button from 'Components/Tailwind/Button';
import React from 'react';

interface Props {}

const Shortcuts = [
    {name: 'Group Elements', keys: ['⌘', 'g']},
    {name: 'Show Groups', keys: ['g']},
    {name: 'Show Padding', keys: ['p']},
    {name: 'Show Margins', keys: ['m']},
    {name: 'Show Widths', keys: ['w']},
    {name: 'Zoom In', keys: ['z (hold) and click']},
    {name: 'Zoom Out', keys: ['x (hold) and click']},
    {name: 'Hand Tool (drag canvas)', keys: ['spacebar']},
    // {name: 'Show Heights', keys: ['h']},
];

export const HotkeyTooltip: React.FC<Props> = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_value, _set, removeCookie] = useCookieValue('rendition-tutorial');
    return (
        <Popover className="relative">
            {({open}) => (
                <>
                    <Popover.Button
                        id="shortcuts-popover"
                        className={classNames(
                            open && 'text-opacity-90',
                            'mr-2 inline-flex h-5 w-5 rounded-full border border-neutral-400',
                            'bg-opacity-15 items-center justify-center text-sm font-bold text-white hover:bg-neutral-400 hover:text-opacity-100'
                        )}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="stroke-white"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"></path>
                            <path d="M12 19l0 .01"></path>
                        </svg>
                    </Popover.Button>
                    <Transition
                        as={React.Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                    >
                        <Popover.Panel className="absolute left-0 z-50 mt-3">
                            <div className="flex w-72 flex-col overflow-hidden rounded-lg bg-neutral-600 p-4 shadow-lg ring-1 ring-black ring-opacity-5">
                                <h1 className="text-base font-black text-white">Keyboard Shortcuts</h1>
                                <div className="mt-4 inline-flex flex-col justify-between gap-2">
                                    {Shortcuts.map(({name, keys}) => (
                                        <div
                                            className="inline-flex w-full flex-row items-center justify-between"
                                            key={`${keys}`}
                                        >
                                            <h4 className="text-[12px] font-normal text-white">{name}</h4>
                                            <div className="inline-flex flex-row items-center gap-0.5 rounded-md border border-neutral-400 px-2 py-1 leading-3">
                                                {keys.map((key) => (
                                                    <span
                                                        className="text-[10px] font-semibold text-neutral-200"
                                                        key={`${name}-${key}`}
                                                    >
                                                        {key}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <Button className="mt-6" outlined onClick={removeCookie}>
                                    Open Tutorial
                                </Button>
                            </div>
                        </Popover.Panel>
                    </Transition>
                </>
            )}
        </Popover>
    );
};
